import { IconButton, styled } from "@mui/material";

export const RoundIconButton = styled(IconButton)({
    width: "fit-content",
    height: "fit-content",
    aspectRatio: "1 / 1",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    "&:hover": { backgroundColor: "transparent" },
});
